export default function CloseBTn() {
  return (
    <svg width="20" height="20" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="38" height="38" rx="19" fill="#FFF4E3" />
      <path
        d="M12.9583 12.9583L25.0416 25.0416M25.0416 12.9583L12.9583 25.0416"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
}
